import { Text, TextProps } from '@chakra-ui/react'

import { useIsDark } from '../../../hooks/useIsDark'
import { CHART_TITLE_VARIANT_STYLES } from './chart.constants'
import { useChartColors } from './useChartColors'

export type ChartTitleVariant = 'default' | 'snapshot'

export interface ChartTitleProps extends TextProps {
  children?: React.ReactNode
  variant?: ChartTitleVariant
}

export const ChartTitle = ({
  children,
  variant = 'default',
  ...props
}: ChartTitleProps) => {
  const chartColors = useChartColors()
  const isDark = useIsDark()
  const variantStyles = CHART_TITLE_VARIANT_STYLES[variant]
  const textColor =
    variant === 'default' || !isDark
      ? chartColors.titleColor
      : variantStyles.textColor

  return (
    <Text
      as="h3"
      fontSize="16px"
      {...variantStyles}
      textColor={textColor}
      {...props}
    >
      {children}
    </Text>
  )
}
